// extracted by mini-css-extract-plugin
module.exports = {"app":"create_app__3OY8T","app_container":"create_app_container__1h3Rk","main__content":"create_main__content__IFClK","save_button":"create_save_button__VjC2b"};